export default __webpack_public_path__ + "static/media/sign-in-background.c3ed4b97.png";